import React from 'react';
import { createRoot } from 'react-dom/client';
import 'semantic-ui-less/semantic.less';
import App from './App';

const container = document.querySelector( '#root' );

document.documentElement.style.setProperty( '--main', 'hsl(260, 75%, 32%)' );
document.documentElement.style.setProperty( '--mainTranslucent', 'hsla(260, 75%, 32%, 50%)' );
document.documentElement.style.setProperty( '--progementum', 'hsl(207, 58%, 54%)' );
document.documentElement.style.setProperty( '--gradient1', 'hsl(260, 75%, 36%)' );
document.documentElement.style.setProperty( '--gradient2', 'hsl(260, 75%, 24%)' );
document.documentElement.style.setProperty( '--gradient3', 'hsl(260, 75%, 12%)' );

const root = createRoot( container );

root.render( <App/> );
